var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b;
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import DeblurOutlinedIcon from "@mui/icons-material/DeblurOutlined";
import HotelOutlinedIcon from "@mui/icons-material/HotelOutlined";
import LocalDiningIcon from "@mui/icons-material/LocalDining";
import TableRestaurantOutlinedIcon from "@mui/icons-material/TableRestaurantOutlined";
import SettingsAccessibilityOutlinedIcon from "@mui/icons-material/SettingsAccessibilityOutlined";
import { ResourceDisplayKind, } from "../../models/aggregation/aggregation.model";
import { ElementChip } from "./base/ElementChip";
export var RESOURCE_ELEMENT_DEFAULT_COLORS = (_a = {},
    _a[ResourceDisplayKind.ACCOMMODATION] = '#3b82f6',
    _a[ResourceDisplayKind.STAFF] = '#10b981',
    _a[ResourceDisplayKind.FACILITY] = '#8b5cf6',
    _a[ResourceDisplayKind.RESTAURANT] = '#f43f5e',
    _a[ResourceDisplayKind.RESTAURANT_TABLE] = '#f43f5e',
    _a);
export var RESOURCE_ELEMENT_ICONS = (_b = {},
    _b[ResourceDisplayKind.ACCOMMODATION] = HotelOutlinedIcon,
    _b[ResourceDisplayKind.STAFF] = SettingsAccessibilityOutlinedIcon,
    _b[ResourceDisplayKind.FACILITY] = DeblurOutlinedIcon,
    _b[ResourceDisplayKind.RESTAURANT] = LocalDiningIcon,
    _b[ResourceDisplayKind.RESTAURANT_TABLE] = TableRestaurantOutlinedIcon,
    _b);
function ResourceElementBase(_a) {
    var kind = _a.kind, name = _a.name, color = _a.color, tooltipContent = _a.tooltipContent, onClick = _a.onClick, _b = _a.asPrint, asPrint = _b === void 0 ? false : _b;
    var trimmedName = name.trim();
    if (!trimmedName)
        return null;
    if (asPrint) {
        return _jsx(_Fragment, { children: trimmedName });
    }
    var Icon = RESOURCE_ELEMENT_ICONS[kind];
    return (_jsx(ElementChip, { text: trimmedName, tooltipContent: tooltipContent, onClick: onClick, startIcon: (_jsx(Icon, { sx: { fontSize: 15, color: color !== null && color !== void 0 ? color : RESOURCE_ELEMENT_DEFAULT_COLORS[kind] } })) }));
}
export function AccommodationElement(props) {
    return _jsx(ResourceElementBase, __assign({}, props, { kind: ResourceDisplayKind.ACCOMMODATION }));
}
export function StaffElement(props) {
    return _jsx(ResourceElementBase, __assign({}, props, { kind: ResourceDisplayKind.STAFF }));
}
export function FacilityElement(props) {
    return _jsx(ResourceElementBase, __assign({}, props, { kind: ResourceDisplayKind.FACILITY }));
}
export function RestaurantElement(props) {
    return _jsx(ResourceElementBase, __assign({}, props, { kind: ResourceDisplayKind.RESTAURANT }));
}
export function RestaurantTableElement(_a) {
    var color = _a.color, parentColor = _a.parentColor, props = __rest(_a, ["color", "parentColor"]);
    return (_jsx(ResourceElementBase, __assign({}, props, { kind: ResourceDisplayKind.RESTAURANT_TABLE, color: color !== null && color !== void 0 ? color : parentColor })));
}
/**
 * Renders a server-classified resource through its dedicated semantic element.
 * Callers do not need to reproduce resource-kind or parent-color rules.
 */
export function ResourceDisplayReferenceElement(_a) {
    var _b, _c;
    var resource = _a.resource, asPrint = _a.asPrint;
    var props = { name: (_b = resource.name) !== null && _b !== void 0 ? _b : '', color: resource.tagColor, asPrint: asPrint };
    switch (resource.kind) {
        case ResourceDisplayKind.ACCOMMODATION:
            return _jsx(AccommodationElement, __assign({}, props));
        case ResourceDisplayKind.STAFF:
            return _jsx(StaffElement, __assign({}, props));
        case ResourceDisplayKind.FACILITY:
            return _jsx(FacilityElement, __assign({}, props));
        case ResourceDisplayKind.RESTAURANT:
            return _jsx(RestaurantElement, __assign({}, props));
        case ResourceDisplayKind.RESTAURANT_TABLE:
            return _jsx(RestaurantTableElement, __assign({}, props, { parentColor: (_c = resource.parent) === null || _c === void 0 ? void 0 : _c.tagColor }));
    }
}
